import { render, staticRenderFns } from "./MasterDataLeaseChassis.vue?vue&type=template&id=0f9a1530&scoped=true"
import script from "./MasterDataLeaseChassis.vue?vue&type=script&lang=js"
export * from "./MasterDataLeaseChassis.vue?vue&type=script&lang=js"
import style0 from "./MasterDataLeaseChassis.vue?vue&type=style&index=0&id=0f9a1530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a1530",
  null
  
)

export default component.exports